import React, { useEffect, useState }from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import { UserCreators } from "redux/modules/user";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';

import Button from "components/common/button/Button";
import BackNavigation from "./common/BackNavigation";
import { useNavigate } from "react-router-dom";



const Uncertificated = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [value, setValue] = useState()
    
    const handleChange = (e) => {
      setValue(Number(e.target.value))
    }

    const submitHandler = () => {
      // 여기서 value 전달
      dispatch(UserCreators.unCertiSignup(value))
      alert('회원가입이 완료되었습니다.')
      navigate('/')
    }

    return (
        <LoginWrapper>
            <BackNavigation/>
            <SignupContainer>
                <Title>
                    해당하는 내용을 선택하고<br/>
                    사업자 등록증 없이 가입하세요<br/>
                </Title>
                <Content>
                    <p style={{marginBottom: "3vh"}}>
                        사업자 등록증이 없으면 꽃집 사장님 혜택을 받을 수 없어요<br/>
                        회원 가입 후에도, 내 정보에서 사업자 인증이 가능해요
                    </p>
                </Content>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  onChange={handleChange}
                >
                  <FormControlLabel 
                    value="0"
                    control={<Radio sx={{
                      root: {
                        fontSize: "10px"
                      },
                      '& .MuiSvgIcon-root': {
                        fontSize: 20,
                      },
                      color: "#DFE2E6",
                      '&.Mui-checked': {
                        color: "#FF7A00",
                      },
                    }}/>} 
                    label={
                        <Box component="div" fontSize="0.9em" color="#222529">
                            꽃집 창업을 준비 중이에요
                        </Box>
                    }
                  />
                  <FormControlLabel value="1" control={<Radio sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 20,
                      },
                      color: "#DFE2E6",
                      '&.Mui-checked': {
                        color: "#FF7A00",
                      },
                    }}/>}
                    label={
                        <Box component="div" fontSize="0.9em" color="#222529">
                            사업자인데, 나중에 인증할게요
                        </Box>
                    }
                  />
                </RadioGroup>
            </SignupContainer>
            <Button wide _onClick={submitHandler}>가입하기</Button>
        </LoginWrapper>
    )
}

const LoginWrapper = styled.div`
  position: relative;
  width: 90%;
  height: 92vh;
  margin: auto;
  padding-top: 15px;
`;

const SignupContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 13vh;
`;

const Title = styled.div`
  font-size: 1.1em;
  font-weight: 600;
  margin-bottom: 2vh;
`;

const Content = styled.div`
  font-size: 0.9em;
  color: #4A5056;
  margin-bottom: 60px;
`;

export default Uncertificated;